import api from './api';
import { Kunde, CreateKundeRequest, UpdateKundeRequest } from '../types';

export const kundeService = {
  getAll: async (): Promise<Kunde[]> => {
    const response = await api.get('/kunden');
    return response.data;
  },

  getById: async (id: number): Promise<Kunde> => {
    const response = await api.get(`/kunden/${id}`);
    return response.data;
  },

  create: async (data: CreateKundeRequest): Promise<Kunde> => {
    const response = await api.post('/kunden', data);
    return response.data;
  },

  update: async (id: number, data: UpdateKundeRequest): Promise<Kunde> => {
    const response = await api.put(`/kunden/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/kunden/${id}`);
  },

  setActive: async (id: number, active: boolean): Promise<Kunde> => {
    const response = await api.patch(`/kunden/${id}/active`, { active });
    return response.data;
  },

  geocode: async (id: number): Promise<Kunde> => {
    const response = await api.post(`/kunden/${id}/geocode`);
    return response.data;
  },

  berechneAnfahrtzeiten: async (): Promise<{ message: string; aktualisiert: number; uebersprungen: number; fehlgeschlagen: number }> => {
    const response = await api.post('/kunden/berechne-anfahrtzeiten', {}, { timeout: 300000 });
    return response.data;
  },

  importCsv: async (file: File): Promise<{ message: string; count: number }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/kunden/import-csv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};

export default kundeService;
